import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-alert-box-dialog',
  templateUrl: './alert-box-dialog.component.html',
  styleUrls: ['./alert-box-dialog.component.scss'],
})
export class AlertBoxDialogComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

}
